<template>
  <div class="main-container">
    <div>
      <Header />
    </div>
    <div :class="['main', { 'main-all': articleRoute }]">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          ><router-link to="/">首页</router-link></el-breadcrumb-item
        >

        <el-breadcrumb-item v-for="item in breadcrumb" :key="item.key">
          <router-link :to="item.link">{{ item.value }}</router-link>
        </el-breadcrumb-item>
      </el-breadcrumb>

      <app-main />
      <div class="footer">
        <div id="community_name">沁恒微电子社区</div>
      </div>
    </div>
    <!-- <div class="floating-box hide-on-mobile" @click="handleClick">
      <el-tooltip
        class="item"
        effect="dark"
        content="意见反馈"
        placement="top-start"
      >
        <i class="el-icon-chat-round"> </i>
      </el-tooltip>
    </div> -->
    <!-- 引入弹窗组件 -->
    <EditorDialog
      :visible.sync="showEditor"
      title="意见&反馈"
      :email="(user && user.email) ? user.email : ''"
      :initial-values="initialData"
    />
  </div>
</template>

<script>
import { Header, AppMain } from "./components";
import { mapGetters } from "vuex";
import EditorDialog from '@/components/FeedBack/index.vue';

export default {
  name: "Layout",
  components: {
    Header,
    AppMain,
    EditorDialog
  },

  computed: {
    ...mapGetters(["breadcrumb"]),
    ...mapGetters(["user"]),
    articleRoute() {
     // console.log(this.$route.path);
     // console.log(this.$route.path.startsWith("/article"));
      return this.$route.path.startsWith("/article");
    },
  },
  watch: {
    "$store.state.app.breadcrumb"(newData) {
      const length = Object.keys(newData).length;
      let value = "首页";
      if (length > 0) {
        value = newData[length - 1].value;
      }
      document.title = value + " - 沁恒微电子社区";
    },
  },
  data() {
    return {
      showEditor: false,
      initialData: {
        // 可以设置初始值
        email: '',
        html: ''
      }
    };
  },
  methods: {
    setTitle() {},
    handleClick() {
      this.showEditor = true;
    },
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
    },
  },
};
</script>

<style lang="less" scoped>
.el-breadcrumb {
  margin-top: 20px;
}
.floating-box {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  background-color: #2469f6;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 1000;
}
.footer {
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: right;
}
/* 移动设备特定样式 */
@media (max-width: 600px) {
  .hide-on-mobile {
    display: none;
  }
}
</style>
